module.exports = __webpack_public_path__ + "static/media/axegpromouse-1.52e02f27.jpg";